import request from '@/utils/request';

export function putMethod(url, obj, header) {
    let headers = {
        isToken: true
    };
    if (header) {
        headers = header;
    }
    return request({
        url,
        data: obj,
        method: 'put',
        headers: headers
    })
}
export function postMethod(url, obj, header) {
    let headers = {
        isToken: true
    };
    if (header) {
        headers = header;
    }
    return request({
        url,
        data: obj,
        method: 'post',
        headers: headers
    })
}
export function getMethod(url, obj, header) {
  
    let headers = {
        isToken: true
    };
    if (header) {
        headers = header;
    }
    return request({
        url,
        params: obj,
        headers: headers
    })
}
export function deleteMethod(url, obj, header) {
    let headers = {
        isToken: true
    };
    if (header) {
        headers = header;
    }
    return request({
        url,
        params: obj,
        method: 'delete',
        headers: headers
    })
}




// WEBPACK FOOTER //
// ./src/api/config.js